module.exports = __webpack_public_path__ + "img/keder_lichtgrau_ral7035.50185ac2.jpg";